import { render } from "./Table.vue?vue&type=template&id=06f83df5"
import script from "./table-controller.js?vue&type=script&lang=js"
export * from "./table-controller.js?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__